module.exports = __webpack_public_path__ + "img/gift-5.dd9e3986.jpg";